import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LandingHeader from '../Shared/LandingHeader';
import LandingFooter from '../Shared/LandingFooter';
import './DemoPage.css';

const DemoPage = () => {
    const { t } = useTranslation(['demo', 'common']);

    const paragraphs = t('demo:hero.paragraphs', { returnObjects: true }) || [];
    const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];

    return (
        <div className="demo-page">
            <LandingHeader activePage="demo" />

            <main style={{ paddingTop: '80px' }}>
                {/* Demo Hero Section */}
                <section className="demo-hero">
                    <div className="container">
                        <div className="demo-hero-content">
                            <h1 className="hero-title">
                                {t('demo:hero.title')} <span className="gradient-text">{t('demo:hero.titleHighlight')}</span>
                            </h1>
                            <div className="hero-subtext">
                                {Array.isArray(paragraphs) && paragraphs.map((p, i) => (
                                    <p key={i}>{p}</p>
                                ))}
                            </div>
                            <Link to="/register" className="btn btn-primary">{t('demo:hero.button')}</Link>
                        </div>
                    </div>
                </section>

                {/* Sample Skill Gap Report */}
                <section id="report" className="report-section">
                    <div className="container">
                        <h2 className="section-title">{t('demo:report.title')} <span className="gradient-text">{t('demo:report.titleHighlight')}</span></h2>
                        <div className="report-container">
                            <div className="report-visual">
                                <div className="skill-bars">
                                    <div className="skill-item">
                                        <span>{t('demo:report.skills.algebra')}</span>
                                        <div className="progress-track"><div className="progress-fill green" style={{ width: '85%' }}></div></div>
                                    </div>
                                    <div className="skill-item">
                                        <span>{t('demo:report.skills.geometry')}</span>
                                        <div className="progress-track"><div className="progress-fill orange" style={{ width: '45%' }}></div></div>
                                    </div>
                                    <div className="skill-item">
                                        <span>{t('demo:report.skills.trigonometry')}</span>
                                        <div className="progress-track"><div className="progress-fill red" style={{ width: '20%' }}></div></div>
                                    </div>
                                </div>
                            </div>
                            <div className="report-details">
                                <h3>{t('demo:report.scoring.title')}</h3>
                                <p>{t('demo:report.scoring.text')}</p>
                                <div className="scoring-legend">
                                    <span className="legend-item"><i className="dot red"></i> {t('demo:report.scoring.legend.weak')}</span>
                                    <span className="legend-item"><i className="dot orange"></i> {t('demo:report.scoring.legend.moderate')}</span>
                                    <span className="legend-item"><i className="dot green"></i> {t('demo:report.scoring.legend.strong')}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Sample Weekly Study Plan */}
                <section id="study-plan" className="plan-section">
                    <div className="container">
                        <h2 className="section-title">{t('demo:plan.title')} <span className="gradient-text">{t('demo:plan.titleHighlight')}</span></h2>
                        <div className="plan-grid">
                            {days.map((day, index) => (
                                <div key={day} className="calendar-card" style={{ animationDelay: `${index * 0.1}s` }}>
                                    <h4>{t(`demo:plan.days.${day}`)}</h4>
                                    <div className="task-icons">
                                        <span title={t('demo:plan.tasks.video')}>📺</span>
                                        <span title={t('demo:plan.tasks.practice')}>✍️</span>
                                        <span title={t('demo:plan.tasks.test')}>✅</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Final CTA */}
                <section className="cta-section container">
                    <h2 style={{ fontSize: '3rem', marginBottom: '1.5rem' }}>{t('demo:cta.title')} <span className="gradient-text">{t('demo:cta.titleHighlight')}</span></h2>
                    <p style={{ marginBottom: '2.5rem', color: 'var(--text-gray)' }}>{t('demo:cta.text')}</p>
                    <Link to="/register" className="btn btn-primary" style={{ fontSize: '1.2rem' }}>{t('demo:cta.button')}</Link>
                </section>
            </main>

            <LandingFooter />
        </div>
    );
};

export default DemoPage;
